import DisclaimerTemplate, { type DisclaimerPayload } from './template';

export default function DisclaimerService(
  pl: DisclaimerPayload = {},
  el: HTMLElement
) {
  if (!pl.notice && !pl.icons && !pl.poweredby) return;

  const disclaimerSlot = el.shadowRoot!.querySelector<HTMLSlotElement>(
    'slot[name="disclaimer"]'
  )!;
  disclaimerSlot.innerHTML = DisclaimerTemplate(pl);
  disclaimerSlot.hidden = false;
}
